const ShopActionsType = {
  UPDATE_COLLECTIONS: "UPDATE_COLLECTIONS",
};

export default ShopActionsType;
